import './AnimatedChangeContent.sass';

import React, { FC, useEffect, useRef, useState } from 'react';

import { classNames } from '$utils';
import { AnimatedChangeContentProps } from './AnimatedChangeContent.interface';

export const AnimatedChangeContent: FC<AnimatedChangeContentProps> = (props) => {
  const { children, animateKey } = props;
  const prev = useRef<any>(children);
  const firstChange = useRef(true);
  const [isChanged, setChanged] = useState(false);

  useEffect(() => {
    if (firstChange.current) {
      firstChange.current = false;
    } else {
      setChanged(true);
      const timer = setTimeout(() => {
        setChanged(false);
        prev.current = children;
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [animateKey]);

  return (
    <div
      className={classNames({
        AnimatedChangeContent: true,
        animate: isChanged,
      })}
    >
      <div className="AnimatedChangeContent__current">{children}</div>
      <div className="AnimatedChangeContent__prev">{prev.current}</div>
    </div>
  );
};
